<template>
  <fin-tabs :tab-items="tabItems"
            @tabChangeNotAllowed="(val, index) => tabChangeNotAllowed(val,index)"
            :background-color-tab-items="$finColors.paleGrey"
            :no-item-content-padding="true"
            @tabChanged="val => tabChanged(val)">
    <template #0>
      <fin-strategy-details-overview-tab :strategy="strategy"/>

      <fin-strategy-details-instruments :asset-class-id="'SHARE'"
                                        :class="$vuetify.breakpoint.xs ? 'pt-4' : 'pt-16'"
                                        v-if="!overviewOnly"
                                        :strategy="strategy"/>

      <fin-strategy-details-others v-if="!overviewOnly"
                                   :class="$vuetify.breakpoint.xs ? 'pt-4' : 'pt-12'"/>

      <fin-strategy-details-read v-if="!overviewOnly"
                                 :class="$vuetify.breakpoint.xs ? 'pt-4' : 'pt-12'"/>
    </template>
    <template #1>
      <fin-strategy-details-approach-tab :strategy="strategy"/>
    </template>
    <template #2>
      <fin-strategy-details-rules-tab :strategy="strategy" :strategy-color="strategyColor"/>
    </template>
    <template #3>
      <fin-strategy-details-backtesting v-if="strategy" :strategy-id="strategy.id"/>
    </template>
    <template #4>
      <fin-share-template-portfolio :strategy="strategy"/>
    </template>
  </fin-tabs>
</template>

<script>
import FinStrategyDetailsOverviewTab from "@/components/pages/finStrategy/details/tabs/overview"
import FinStrategyDetailsInstruments from "@/components/pages/finStrategy/details/tabs/overview/instruments"
import FinStrategyDetailsOthers from "@/components/pages/finStrategy/details/tabs/overview/others"
import FinStrategyDetailsRead from "@/components/pages/finStrategy/details/tabs/overview/read"
import FinStrategyDetailsApproachTab from "@/components/pages/finStrategy/details/tabs/approach"
import FinStrategyDetailsRulesTab from "@/components/pages/finStrategy/details/tabs/rules/index"
import FinTabs from "@/components/common/Tabs"
import FinShareTemplatePortfolio
  from "@/components/pages/finStrategy/details/tabs/templateportfolio/ShareTemplatePorfolio"
import FinStrategyDetailsBacktesting from "@/components/pages/finStrategy/details/tabs/backtesting"
import AmplitudePush from "@/mixins/AmplitudePush"
import PriceModel from "@/mixins/PriceModel"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import {EventBus} from "@/plugins/fincraft"

export default {
  name: "finStrategyDetailsTabs",
  components: {
    FinStrategyDetailsBacktesting,
    FinShareTemplatePortfolio,
    FinTabs,
    FinStrategyDetailsRulesTab,
    FinStrategyDetailsApproachTab,
    FinStrategyDetailsOverviewTab,
    FinStrategyDetailsInstruments,
    FinStrategyDetailsOthers,
    FinStrategyDetailsRead
  },
  mixins: [AmplitudePush, PriceModel],
  props: {
    strategy: {
      type: Object,
      default: undefined
    },
    strategyColor: {
      type: String,
      default: 'transparent'
    },
    /** Only display the first part of the strategy details page. Needed because of onboarding */
    overviewOnly: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    tabItems() {
      const aboLevels = this.priceModelEnabledAndLevels(PRICEMODEL_FEATURE_IDS.STRATEGIES.id)
      const allowed = aboLevels && aboLevels.length > 0 &&
        aboLevels.findIndex(i => i.id === 'STRATEGIES_SAMPLE_PORTFOLIO_INCL_BACKTESTING') !== -1
      return [
        {name: "Übersicht"},
        {name: "Vorgehensweise"},
        {name: "Regelwerk"},
        {
          name: "Backtesting",
          allowed: allowed
        },
        {
          name: "Musterportfolio",
          allowed: allowed
        }
      ]
    }
  },
  methods: {
    tabChanged(val) {
      this.trackToAmplitude('tabs', 'change_tab', this.tabItems[val].name)
    },
    trackToAmplitude(positionOnPage, action, stepChoice) {
      const event = {
        'event': 'fincraft_strategy_details_' + positionOnPage + "_" + action,
        'step': action,
        'placement': 'strategy_details_' + positionOnPage,
        'vue_breakpoint': this.$vuetify.breakpoint.name,
        'step_choice': stepChoice
      }
      this.pushToAmplitude(event)
    },
    tabChangeNotAllowed(tab) {
      if (tab.name === 'Backtesting') {
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.STRATEGIES.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUALITY, {level: 'STRATEGIES_SAMPLE_PORTFOLIO_INCL_BACKTESTING'})
      } else if (tab.name === 'Musterportfolio') {
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.STRATEGIES.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUALITY, {level: 'STRATEGIES_SAMPLE_PORTFOLIO_INCL_BACKTESTING'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
